import { render, staticRenderFns } from "./NotificationItemMini.vue?vue&type=template&id=6768f736&"
import script from "./NotificationItemMini.vue?vue&type=script&lang=js&"
export * from "./NotificationItemMini.vue?vue&type=script&lang=js&"
import style0 from "./NotificationItemMini.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports